module.exports = __webpack_public_path__ + "img/driver-photo-sample.c906ad4a.png";